import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconStatisticsSvg } from "./IconStatisticsSvg.mjs";
const IconStatistics = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconStatisticsSvg, ...svgProps }) });
export {
  IconStatistics
};
